import { Poppins, Quicksand } from 'next/font/google';
import Image from 'next/image'
import React from 'react'
const quickSand =Quicksand({weight:"400", subsets:['latin']});
const popins =Poppins({weight:"400", subsets:['latin']});
const extraPopins =Poppins({weight:"500", subsets:['latin']});
export default function LearnsoftStrenght() {

    const StrengthtData = [
        {
            icon:"/about-img/learners.svg",
            total:"5000+",
            heading:"Learners & Counting"
        },
        {
            icon:"/about-img/total-courses.svg",
            total:"70+",
            heading:"Total Courses"
        },
        {
            icon:"/about-img/victory.svg",
            total:"4000+",
            heading:"Successfull Students"
        },
    ] 

  return (
    <>
    <section className='bg-img mt32 pdtb70'>
        <div className=' container '>
        <div className='df gap20 tfdc '>
             <div className=''>
                {StrengthtData.map((items,index)=>{
                    return(
              <div className='box mt10'>
                <div className='df fac gap16'>
                  <Image src={items.icon} width={47} height={44} alt={`${items.heading}-Icon`} loading='lazy'/>
                  <div className=''>
                    <p className={`fs20 lnh30 ls05 mfs-18 fwb ${extraPopins.className}`}>{items.total}</p> 
                    <p className={`fs20 lnh30 ls05 mfs-18 pdt4 ${popins.className}`}>{items.heading}</p> 
                </div>
              </div>
              </div>
              )
            })}
        </div>   
        <div className=''>
        <h4 className={`fs-33 mfs-24 ${extraPopins.className}`}>Strength in  <span className={`ylw-clr ${extraPopins.className}`}>  Numbers </span></h4>
       <p className={`fs-16 mt32 mmt16 ${popins.className}`}>With over 5,000 students learning from Learnsoft, 4,000+ certified graduates, and 70+ courses offered, we empower individuals through strength in numbers, delivering quality education and impactful certifications</p>
        <div className='pd20 learnsoft-logo df fac gap16 mt32 mmt16'>
          <Image src={"/header/logo.webp"} width={77} height={81} alt='Learnsoft-Logo' loading='lazy' quality={100}/>
          <div className=''>
          <p className={`fs-24 mf-19 fwb ylw-clr ${extraPopins.className}`}>Learnsoft.org</p>
          <p className={`fs-14 pdt5 cw ${popins.className}`}>Training | Internship | Placement</p>
          </div>
        </div>
        </div>     
        </div>  
        </div>
    </section>
 <style jsx>
    {`
            .bg-img{
            background-image: url('/home-v2-images/why-choose-bg.webp');
            width:100%;
            height: auto;
            
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
           
            background-size: 100% 100%;
        }
            .box{
            width: 380px;
            padding: 20px 20px; 
            background: #ffffff;
            border-radius: 8px;

            }
            .learnsoft-logo{
            width: 328px;
             background: #000000;
             border-radius: 10px;
             
            }
           
            @media only screen and (max-width: 430px){
                        .box{
            width: auto;
            padding: 20px 20px; 
            background: #ffffff;
            border-radius: 8px;

            }
        .learnsoft-logo{
            width: auto;
             background: #000000;
             border-radius: 10px;
             
            }
            }
    @media only screen and (max-width:1250px){
    .tfdc{
      flex-wrap:wrap;
      align-items: center;
      justify-content: center;
      }
    `}
 </style>
</>
  )
}
